/* Optional review after the shopper returns from Shopify Checkout. */
(function () {
  var CART_KEY = 'encanto_review_cart';
  var CHECKOUT_AT_KEY = 'encanto_checkout_at';
  var HIDDEN_AT_KEY = 'encanto_checkout_hidden_at';
  var CLOSED_KEY = 'encanto_review_closed_token';
  var CHECKOUT_MAX_AGE_MS = 6 * 60 * 60 * 1000;
  var CHECKOUT_MIN_AWAY_MS = 3000;
  var STAR_PATH = 'M12 2.4l2.7 5.5 6.1.9-4.4 4.3 1 6.1L12 16.3 6.6 19.2l1-6.1L3.2 8.8l6.1-.9L12 2.4z';

  var sheetConfig = readJsonElement('encanto-review-config');
  if (!sheetConfig || !sheetConfig.strings) return;

  var copy = plainCopy(sheetConfig.strings);
  var liveCart = readJsonElement('encanto-review-cart');

  // Shopify's captcha calls form.submit after it writes the token.
  // Replace that method first so the post stays on this page.
  armContactForm();
  rememberLiveCart();
  watchCheckoutStart();
  watchCartUpdates();
  boot();

  function boot() {
    var inlineHost = document.getElementById('enc-review-inline');
    if (inlineHost) mountInline(inlineHost);
    if (sheetConfig.designMode) return;
    if (previewRequested()) {
      openPreview();
      return;
    }
    if (!inlineHost) offerAfterCheckout();
  }

  function rememberLiveCart() {
    if (!liveCart || liveCart.count < 1 || !liveCart.items || !liveCart.items.length) return;
    writeJson(CART_KEY, liveCart);
  }

  function watchCheckoutStart() {
    document.addEventListener('click', onCheckoutClick, true);
    document.addEventListener('submit', onCheckoutSubmit, true);
    window.addEventListener('pagehide', stampCheckoutHide);
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) offerAfterCheckout();
    });
  }

  function watchCartUpdates() {
    function bind() {
      if (!window.jQuery || window.jQuery(document).data('encReviewCart')) return;
      window.jQuery(document).data('encReviewCart', true);
      window.jQuery(document).on('cart:updated cart:refresh', refreshCartSoon);
    }
    bind();
    window.addEventListener('load', bind);
  }

  function onCheckoutClick(event) {
    var control = event.target && event.target.closest
      ? event.target.closest('[name="checkout"], a[href*="/checkout"], .shopify-payment-button, .additional-checkout-buttons')
      : null;
    if (!control) return;
    saveCartNow();
  }

  function onCheckoutSubmit(event) {
    var form = event.target;
    if (!form || !form.querySelector) return;
    var checkoutButton = form.querySelector('[name="checkout"]');
    var action = form.getAttribute('action') || '';
    if (!checkoutButton && action.indexOf('/checkout') === -1) return;
    saveCartNow();
  }

  // The drawer updates the cart without reloading, so the HTML snapshot is stale.
  // Read /cart.js before the browser leaves for Shopify Checkout.
  function saveCartNow() {
    var now = Date.now();
    if (now - numberFromStorage(CHECKOUT_AT_KEY) < 1500) return;
    var cart = readCartSync();
    if (cart && cart.item_count > 0) writeJson(CART_KEY, cartSnapshot(cart));
    else rememberLiveCart();
    try {
      localStorage.setItem(CHECKOUT_AT_KEY, String(now));
      localStorage.removeItem(CLOSED_KEY);
    } catch (storageError) {
      if (storageError.name !== 'SecurityError') throw storageError;
    }
  }

  function refreshCartSoon() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        if (cart.item_count > 0) writeJson(CART_KEY, cartSnapshot(cart));
      })
      .catch(function () {});
  }

  function readCartSync() {
    try {
      var request = new XMLHttpRequest();
      request.open('GET', '/cart.js', false);
      request.send(null);
      if (request.status < 200 || request.status >= 300) return null;
      return JSON.parse(request.responseText);
    } catch (requestError) {
      return null;
    }
  }

  function cartSnapshot(cart) {
    var items = [];
    var seen = {};
    (cart.items || []).forEach(function (line) {
      var productId = line.product_id;
      if (!productId || seen[productId] || !line.handle) return;
      seen[productId] = true;
      items.push({
        id: productId,
        handle: line.handle,
        title: line.product_title || line.title || '',
        image: line.image || '',
        variant: line.variant_title && line.variant_title !== 'Default Title' ? line.variant_title : ''
      });
    });
    return { token: cart.token || '', count: items.length, items: items };
  }

  function stampCheckoutHide() {
    if (!storageGet(CHECKOUT_AT_KEY)) return;
    try {
      localStorage.setItem(HIDDEN_AT_KEY, String(Date.now()));
    } catch (storageError) {
      if (storageError.name !== 'SecurityError') throw storageError;
    }
  }

  function previewRequested() {
    return new URLSearchParams(window.location.search).get('enc_review') === 'preview';
  }

  function openPreview() {
    var products = liveCart && liveCart.items && liveCart.items.length ? liveCart.items : savedProducts();
    if (!products.length) return;
    openGate(products);
  }

  function offerAfterCheckout() {
    var startedAt = numberFromStorage(CHECKOUT_AT_KEY);
    if (!startedAt || Date.now() - startedAt > CHECKOUT_MAX_AGE_MS) return;
    if (storageGet(CLOSED_KEY) === String(startedAt)) return;
    var saved = readJson(CART_KEY);
    if (!saved || !saved.items || !saved.items.length) return;

    readCart().then(function (cart) {
      if (cartIsEmpty(cart) || cameFromThankYou()) {
        openGate(saved.items);
        return;
      }
      if (!leftForCheckout()) {
        clearCheckoutFlag();
        return;
      }
      // Checkout can return before Shopify has cleared the cart.
      window.setTimeout(function () {
        readCart().then(function (again) {
          if (cartIsEmpty(again) || cameFromThankYou()) openGate(saved.items);
          else clearCheckoutFlag();
        }).catch(function () {
          openGate(saved.items);
        });
      }, 1500);
    }).catch(function () {
      if (cameFromThankYou() || leftForCheckout()) openGate(saved.items);
    });
  }

  function readCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Cart ' + response.status);
      return response.json();
    });
  }

  function cartIsEmpty(cart) {
    return !cart || !cart.item_count;
  }

  function cameFromThankYou() {
    return /\/checkouts\/|\/checkout\/|thank[-_]you|checkout\.shopify|shop\.app|shop\.pay|pay\.shopify/i.test(document.referrer || '');
  }

  function leftForCheckout() {
    var startedAt = numberFromStorage(CHECKOUT_AT_KEY);
    var hiddenAt = numberFromStorage(HIDDEN_AT_KEY);
    return hiddenAt > 0 && startedAt > 0 && hiddenAt + 1000 >= startedAt && Date.now() - hiddenAt >= CHECKOUT_MIN_AWAY_MS;
  }

  function clearCheckoutFlag() {
    try {
      localStorage.removeItem(CHECKOUT_AT_KEY);
    } catch (storageError) {
      if (storageError.name !== 'SecurityError') throw storageError;
    }
  }

  function savedProducts() {
    var saved = readJson(CART_KEY);
    return saved && saved.items ? saved.items : [];
  }

  function mountInline(host) {
    var productNode = host.querySelector('[data-enc-review-products]');
    var products = productNode ? parseJson(productNode.textContent) : [];
    if (!products || !products.length) return;
    host.appendChild(buildSheet(products, true).root);
    host.hidden = false;
  }

  function openGate(products) {
    var gate = document.getElementById('enc-review-gate');
    if (!gate || gate.querySelector('[data-enc-review-ready]')) return;
    var built = buildSheet(products, false);
    var frame = gate.querySelector('.enc-review');
    frame.appendChild(built.bar);
    frame.appendChild(built.scroll);
    frame.appendChild(built.foot);
    frame.setAttribute('data-enc-review-ready', '');
    gate.hidden = false;
    document.documentElement.classList.add('enc-review-lock');
    var nameInput = frame.querySelector('input[name="enc-review-name"]');
    if (nameInput) nameInput.focus();
    gate.addEventListener('keydown', trapTab);
  }

  function buildSheet(products, inline) {
    var bar = el('div', 'enc-review__bar');
    bar.appendChild(el('p', 'enc-review__eyebrow', copy.eyebrow));
    bar.appendChild(closeButton());

    var scroll = el('div', 'enc-review__scroll');
    var title = el('h2', 'enc-review__title');
    title.id = inline ? 'enc-review-inline-title' : 'enc-review-title';
    title.appendChild(seal());
    title.appendChild(document.createTextNode(inline ? copy.inlineTitle : copy.title));
    scroll.appendChild(title);
    scroll.appendChild(el('p', 'enc-review__lede', inline ? copy.inlineLede : copy.lede));
    scroll.appendChild(identityFields());
    scroll.appendChild(productList(products));

    var foot = el('div', 'enc-review__foot');
    var hint = el('p', 'enc-review__hint');
    hint.hidden = true;
    var skip = button(copy.skip, 'enc-review__btn enc-review__btn--ghost');
    var send = button(copy.sendOne, 'enc-review__btn enc-review__btn--solid');
    foot.appendChild(hint);
    foot.appendChild(skip);
    foot.appendChild(send);

    var root = el('div', 'enc-review');
    if (inline) {
      root.appendChild(bar);
      root.appendChild(scroll);
      root.appendChild(foot);
    }

    skip.addEventListener('click', function () { dismissSheet(skip); });
    send.addEventListener('click', function () { submitSheet(scroll, send, hint); });
    scroll.addEventListener('change', function () { send.textContent = sendLabel(scroll); });

    return { root: root, bar: bar, scroll: scroll, foot: foot };
  }

  function closeButton() {
    var buttonNode = button(copy.close, 'enc-review__x');
    buttonNode.setAttribute('aria-label', copy.close);
    buttonNode.textContent = '';
    buttonNode.appendChild(closeIcon());
    buttonNode.addEventListener('click', function () {
      dismissSheet(buttonNode.closest('.enc-review') || buttonNode.closest('.enc-review-gate'));
    });
    return buttonNode;
  }

  function seal() {
    var mark = el('span', 'enc-review__seal');
    mark.setAttribute('aria-hidden', 'true');
    mark.appendChild(starSvg());
    return mark;
  }

  function identityFields() {
    var row = el('div', 'enc-review__who');
    row.appendChild(textField('enc-review-name', copy.name, sheetConfig.name || '', 'name'));
    row.appendChild(textField('enc-review-email', copy.email, sheetConfig.email || '', 'email'));
    return row;
  }

  function textField(name, label, value, autocomplete) {
    var field = el('label', 'enc-review__field');
    field.appendChild(el('span', '', label));
    var input = document.createElement('input');
    input.name = name;
    input.type = autocomplete === 'email' ? 'email' : 'text';
    input.autocomplete = autocomplete;
    input.required = true;
    input.value = value;
    field.appendChild(input);
    return field;
  }

  function productList(products) {
    var list = el('ul', 'enc-review__list');
    products.forEach(function (product) {
      if (!product || !product.id || !product.handle) return;
      list.appendChild(productCard(product));
    });
    return list;
  }

  function productCard(product) {
    var card = el('li', 'enc-review__card');
    card.setAttribute('data-enc-product', '');
    card.dataset.id = String(product.id);
    card.dataset.handle = product.handle;
    card.dataset.title = product.title || '';
    card.dataset.image = absoluteUrl(product.image || '');
    card.appendChild(productPhoto(product));
    var meta = el('div', 'enc-review__meta');
    meta.appendChild(el('p', 'enc-review__name', product.title || ''));
    if (product.variant && product.variant !== 'Default Title') {
      meta.appendChild(el('p', 'enc-review__variant', product.variant));
    }
    meta.appendChild(starGroup(product));
    card.appendChild(meta);
    var note = document.createElement('textarea');
    note.name = 'enc-review-note';
    note.maxLength = 600;
    note.rows = 2;
    note.placeholder = copy.comment;
    card.appendChild(note);
    return card;
  }

  function productPhoto(product) {
    if (!product.image) {
      var blank = el('span', 'enc-review__photo enc-review__photo--empty');
      blank.setAttribute('aria-hidden', 'true');
      return blank;
    }
    var image = document.createElement('img');
    image.className = 'enc-review__photo';
    image.alt = '';
    image.src = absoluteUrl(product.image);
    image.width = 72;
    image.height = 72;
    return image;
  }

  function starGroup(product) {
    var group = el('div', 'enc-review__stars');
    group.setAttribute('data-enc-rating', '');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', product.title || '');
    for (var value = 1; value <= 5; value += 1) {
      group.appendChild(starChoice(product, value));
    }
    return group;
  }

  function starChoice(product, value) {
    var label = el('label', 'enc-review__star');
    var input = document.createElement('input');
    input.type = 'radio';
    input.name = 'enc-review-star-' + product.id;
    input.value = String(value);
    input.setAttribute('aria-label', copy.star.replace('__TITLE__', product.title || '').replace('__VALUE__', String(value)));
    label.appendChild(input);
    label.appendChild(starSvg());
    input.addEventListener('change', function () { paintStars(label.parentNode, value); });
    label.addEventListener('mouseenter', function () { paintStars(label.parentNode, value); });
    label.addEventListener('mouseleave', function () {
      var chosen = label.parentNode.querySelector('input:checked');
      paintStars(label.parentNode, chosen ? Number(chosen.value) : 0);
    });
    return label;
  }

  function paintStars(group, rating) {
    var stars = group.querySelectorAll('.enc-review__star');
    for (var index = 0; index < stars.length; index += 1) {
      stars[index].classList.toggle('is-on', index < rating);
    }
  }

  function submitSheet(scroll, send, hint) {
    var draft = collectReviews(scroll);
    if (!draft.ok) {
      hint.hidden = false;
      hint.textContent = copy.missing;
      return;
    }
    hint.hidden = true;
    send.disabled = true;
    send.textContent = copy.sending;
    postReviews(draft.reviews).then(function (emailed) {
      showThanks(scroll, emailed);
    }).catch(function () {
      send.disabled = false;
      send.textContent = sendLabel(scroll);
      hint.hidden = false;
      hint.textContent = copy.error;
    });
  }

  function collectReviews(scroll) {
    var author = fieldValue(scroll, 'enc-review-name');
    var email = fieldValue(scroll, 'enc-review-email');
    var reviews = [];
    var cards = scroll.querySelectorAll('[data-enc-product]');
    cards.forEach(function (card) {
      var chosen = card.querySelector('input:checked');
      if (!chosen) return;
      var note = card.querySelector('textarea');
      var words = note ? note.value.trim() : '';
      reviews.push({
        productId: Number(card.dataset.id),
        handle: card.dataset.handle,
        productTitle: card.dataset.title,
        image: card.dataset.image,
        rating: Number(chosen.value),
        author: author,
        email: email,
        body: words || (chosen.value + '/5')
      });
    });
    return {
      ok: author.length > 0 && email.indexOf('@') > 0 && email.indexOf('.') > email.indexOf('@') && reviews.length > 0,
      reviews: reviews
    };
  }

  function postReviews(reviews) {
    var pending = reviews.map(function (review) {
      return postRyviu(review).then(function () {
        return null;
      }).catch(function (reviewError) {
        if (!(reviewError instanceof Error)) throw reviewError;
        return review;
      });
    });
    return Promise.all(pending).then(function (failures) {
      var missed = failures.filter(Boolean);
      if (!missed.length) return false;
      return postContact(missed).then(function () { return true; });
    });
  }

  function postRyviu(review) {
    var domain = reviewDomain();
    return fetch(ryviuUrl(domain), {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: JSON.stringify(ryviuBody(review, domain))
    }).then(function (response) {
      return response.json();
    }).then(function (reply) {
      if (reply && reply.status === 'error') throw new Error(reply.msg || 'Ryviu rejected the review');
    });
  }

  function reviewDomain() {
    if (window.Shopify && window.Shopify.shop) return window.Shopify.shop;
    return sheetConfig.domain;
  }

  function ryviuUrl(domain) {
    return 'https://app.ryviu.io/frontend/client/customer-write-review?domain=' + encodeURIComponent(domain);
  }

  function ryviuBody(review, domain) {
    return {
      shopInfo: JSON.stringify({
        domain: domain,
        handle: review.handle,
        product_id: review.productId,
        info_client: {}
      }),
      reviewData: JSON.stringify({
        rating: review.rating,
        cname: review.author,
        cemail: review.email,
        ctitle: reviewTitle(review),
        ccontent: review.body,
        img_urls: [],
        title_product: review.productTitle,
        image_product: review.image || ''
      }),
      images: [],
      platform: 'shopify'
    };
  }

  function postContact(reviews) {
    var form = document.getElementById('enc-review-contact');
    if (!form) return Promise.reject(new Error('Missing contact form'));
    var fields = contactFields(form);
    fields.name.value = reviews[0].author;
    fields.email.value = reviews[0].email;
    fields.body.value = contactBody(reviews);
    return bindCaptcha(form).then(function () {
      return waitForContactSubmit(form);
    });
  }

  function contactFields(form) {
    var name = form.elements['contact[name]'];
    var email = form.elements['contact[email]'];
    var body = form.elements['contact[body]'];
    if (!name || !email || !body) throw new Error('Contact fields missing');
    return { name: name, email: email, body: body };
  }

  function bindCaptcha(form) {
    if (form.getAttribute('data-hcaptcha-bound') === 'true') return Promise.resolve();
    var captcha = window.Shopify && window.Shopify.captcha;
    if (!captcha || typeof captcha.protect !== 'function') return Promise.resolve();
    return new Promise(function (resolve) {
      var timer = window.setTimeout(resolve, 8000);
      captcha.protect(form, function () {
        window.clearTimeout(timer);
        resolve();
      });
    });
  }

  function waitForContactSubmit(form) {
    if (form.dataset.encContactArmed !== '1') return sendContact(form);
    return new Promise(function (resolve, reject) {
      var timer = window.setTimeout(function () {
        form.encContactPending = null;
        reject(new Error('Contact timed out'));
      }, 20000);
      form.encContactPending = {
        resolve: function () {
          window.clearTimeout(timer);
          resolve();
        },
        reject: function (error) {
          window.clearTimeout(timer);
          reject(error);
        }
      };
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else deliverContact(form);
    });
  }

  function armContactForm() {
    var form = document.getElementById('enc-review-contact');
    if (!form || form.dataset.encContactArmed) return;
    form.noValidate = true;
    form.addEventListener('submit', function (event) { event.preventDefault(); });
    var alreadyBound = form.getAttribute('data-hcaptcha-bound') === 'true';
    form.dataset.encContactArmed = alreadyBound ? 'late' : '1';
    if (alreadyBound) return;
    try {
      form.submit = function () { deliverContact(form); };
    } catch (assignError) {
      if (assignError.name !== 'TypeError') throw assignError;
      form.dataset.encContactArmed = 'late';
    }
  }

  function deliverContact(form) {
    var pending = form.encContactPending;
    if (!pending) return;
    form.encContactPending = null;
    sendContact(form).then(pending.resolve, pending.reject);
  }

  function sendContact(form) {
    return fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Contact ' + response.status);
      return response.text().then(function (html) {
        if (!contactAccepted(response, html)) throw new Error('Contact was not accepted');
      });
    });
  }

  function contactAccepted(response, html) {
    if (html.indexOf('data-enc-review-post="error"') !== -1) return false;
    if (html.indexOf('data-enc-review-post="ok"') !== -1) return true;
    return response.url.indexOf('contact_posted=true') !== -1;
  }

  function contactBody(reviews) {
    return reviews.map(function (review) {
      return review.productTitle + ' (' + review.handle + ')\n' + review.rating + '/5\n' + review.body;
    }).join('\n\n');
  }

  function reviewTitle(review) {
    var words = review.body === review.rating + '/5' ? '' : review.body;
    if (!words) return review.rating + '/5';
    return words.length > 80 ? words.slice(0, 77) + '...' : words;
  }

  function showThanks(scroll, emailed) {
    var sheet = scroll.closest('.enc-review');
    var foot = sheet.querySelector('.enc-review__foot');
    scroll.replaceChildren();
    var done = el('div', 'enc-review__done');
    done.appendChild(el('h2', '', copy.thanksTitle));
    done.appendChild(el('p', '', emailed ? copy.thanksEmail : copy.thanksLede));
    scroll.appendChild(done);
    foot.replaceChildren();
    var next = button(copy.continue, 'enc-review__btn enc-review__btn--solid');
    next.addEventListener('click', function () {
      if (sheet.closest('#enc-review-gate')) {
        closeGate();
        window.location.href = sheetConfig.continueUrl || '/';
        return;
      }
      dismissSheet(sheet);
    });
    foot.appendChild(next);
    next.focus();
    dismissCheckoutOffer();
  }

  function dismissSheet(node) {
    var gate = document.getElementById('enc-review-gate');
    if (gate && (node === gate || gate.contains(node))) {
      closeGate();
    } else if (node) {
      var inlineHost = document.getElementById('enc-review-inline');
      if (inlineHost) inlineHost.hidden = true;
    }
    dismissCheckoutOffer();
  }

  function closeGate() {
    var gate = document.getElementById('enc-review-gate');
    if (!gate) return;
    gate.hidden = true;
    document.documentElement.classList.remove('enc-review-lock');
  }

  function dismissCheckoutOffer() {
    var startedAt = storageGet(CHECKOUT_AT_KEY);
    try {
      if (startedAt) localStorage.setItem(CLOSED_KEY, startedAt);
      localStorage.removeItem(CHECKOUT_AT_KEY);
    } catch (storageError) {
      if (storageError.name !== 'SecurityError') throw storageError;
    }
  }

  function trapTab(event) {
    if (event.key === 'Escape') {
      dismissSheet(document.getElementById('enc-review-gate'));
      return;
    }
    if (event.key !== 'Tab') return;
    var gate = document.getElementById('enc-review-gate');
    var focusable = gate.querySelectorAll('button, input, textarea, a[href]');
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function sendLabel(scroll) {
    var count = scroll.querySelectorAll('[data-enc-product] input:checked').length;
    if (count > 1) return copy.sendMany.replace('__COUNT__', String(count));
    return copy.sendOne;
  }

  function fieldValue(scope, name) {
    var input = scope.querySelector('[name="' + name + '"]');
    return input ? input.value.trim() : '';
  }

  function absoluteUrl(url) {
    if (url.indexOf('//') === 0) return 'https:' + url;
    return url;
  }

  function starSvg() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', STAR_PATH);
    svg.appendChild(path);
    return svg;
  }

  function closeIcon() {
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('width', '18');
    svg.setAttribute('height', '18');
    svg.setAttribute('aria-hidden', 'true');
    var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    path.setAttribute('d', 'M6 6l12 12M18 6L6 18');
    path.setAttribute('fill', 'none');
    path.setAttribute('stroke', 'currentColor');
    path.setAttribute('stroke-width', '1.6');
    svg.appendChild(path);
    return svg;
  }

  function button(label, className) {
    var node = document.createElement('button');
    node.type = 'button';
    node.className = className;
    node.textContent = label;
    return node;
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text) node.textContent = text;
    return node;
  }

  function numberFromStorage(key) {
    var raw = storageGet(key);
    var parsed = raw ? Number(raw) : 0;
    return parsed > 0 ? parsed : 0;
  }

  function plainCopy(strings) {
    var copy = {};
    Object.keys(strings).forEach(function (key) {
      copy[key] = decodeShopText(strings[key]);
    });
    return copy;
  }

  // The t filter writes &#39; into this JSON script, and the script does not decode it.
  function decodeShopText(text) {
    if (typeof text !== 'string' || text.indexOf('&') === -1) return text;
    return text
      .replace(/&#0*39;/g, "'")
      .replace(/&#x0*27;/gi, "'")
      .replace(/&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }

  function readJsonElement(id) {
    var node = document.getElementById(id);
    if (!node) return null;
    return parseJson(node.textContent);
  }

  function parseJson(raw) {
    try {
      return JSON.parse(raw);
    } catch (parseError) {
      if (parseError.name !== 'SyntaxError') throw parseError;
      return null;
    }
  }

  function readJson(key) {
    var raw = storageGet(key);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (parseError) {
      if (parseError.name !== 'SyntaxError') throw parseError;
      localStorage.removeItem(key);
      return null;
    }
  }

  function writeJson(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch (storageError) {
      if (storageError.name !== 'SecurityError' && storageError.name !== 'QuotaExceededError') throw storageError;
    }
  }

  function storageGet(key) {
    try {
      return localStorage.getItem(key);
    } catch (storageError) {
      if (storageError.name !== 'SecurityError') throw storageError;
      return null;
    }
  }
})();
